module.exports = __webpack_public_path__ + "img/l.366bde4c.webp";